/**
 * Created by pomoho on 15/9/15.
 */
import data from './data.js';
import ga from './ga.js';


let locale = (navigator.language || navigator.userLanguage || navigator.browserLanguage).toLowerCase().replace('-', '_');
if (data.mainText[locale]) {
	document.title = data.mainText[locale][0]['pageTitle'];
	document.getElementById('textWrapper').innerHTML = template('itemList', {list: data.mainText[locale]});
	document.getElementById('coverText').innerHTML = template('coverList', {list: data.coverText[locale]});
} else {
	document.title = data.mainText[locale][0]['en_us'];
	document.getElementById('textWrapper').innerHTML = template('itemList', {list: data.mainText['en_us']});
	document.getElementById('coverText').innerHTML = template('coverList', {list: data.coverText['en_us']});
}
let usedLink;
let u = navigator.userAgent;
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
let referrer = window.location.search.substring(1).split('=')[1];
let googlePlayUrl = (referrer == '' || referrer == undefined) ?
	'https://play.google.com/store/apps/details?id=com.emoji.keyboard.touchpal' :
'https://play.google.com/store/apps/details?id=com.emoji.keyboard.touchpal&referrer=' + referrer;
let appStoreUrl = 'http://app.appsflyer.com/id909654683';

if (isiOS) {
	usedLink = appStoreUrl;
} else if (isAndroid) {
	usedLink = googlePlayUrl;
} else {
	usedLink = 'http://ime.service.cootek.com/default/webpage/download_redirect/download.html';
}
let downloadButton = document.getElementsByClassName('button')[0];
downloadButton.onclick = function () {
	ga('send', 'event', 'download');
	//document.getElementById('cover').style.display = 'block';
	if (u.toLowerCase().indexOf('micromessenger') >= 0) {
		document.getElementById('cover').style.display = 'block';
	}else{
		window.location.href = usedLink;
	}
};



/** WEBPACK FOOTER **
 ** ./src/scripts/basic/invite.js
 **/